import styled from 'styled-components';

import { ColumnBlock } from '../../../../styled';

export const Wrapper = styled(ColumnBlock)`
  padding: 5px 0;
  gap: 4px;
`;

export const IconWrapper = styled.div`
  min-width: 24px;
`;

export const TooltipWrapper = styled.div`
  position: relative;
`;

export const Text = styled.p<{ hasError: boolean }>`
  color: ${(props) => (props.hasError ? props.theme.colors.white : props.theme.colors.muted)};
  font-size: 12px;
  line-height: 24px;
  vertical-align: center;
`;
